// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__1lRU0","inner":"Form_inner__W-Mwa","range":"Form_range__O9_W6","name":"Form_name__1SpwC","actions":"Form_actions__13uly"};